"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.84,15.66a.17.17,0,0,0-.17.17V16H16v-.17a.17.17,0,1,0-.35,0v8a.17.17,0,0,0,.35,0v-3h7.68v3a.17.17,0,1,0,.35,0v-8A.17.17,0,0,0,23.84,15.66Zm-.17,2.09H23v.7h.7v.7H23v.7h.7v.7H23v-.7h-.7v.7h-.7v-.7h-.7v.7h-.7v-.7h-.7v.7h-.7v-.7h-.7v.7h-.7v-.7h-.7v.7H16v-.7h.7v-.7H16v-.7h.7v-.7H16v-.7h.7v-.7h.7v.7h.7v-.7h.7v.7h.7v-.7h.7v.7h.7v-.7h.7v.7h.7v-.7H23v.7h.7Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "16.68",
    y: "17.05",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "18.08",
    y: "17.05",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "19.48",
    y: "17.05",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "20.87",
    y: "17.05",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "22.27",
    y: "17.05",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "17.38",
    y: "17.75",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "18.78",
    y: "17.75",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "20.17",
    y: "17.75",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "21.57",
    y: "17.75",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "16.68",
    y: "18.45",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "18.08",
    y: "18.45",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "19.48",
    y: "18.45",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "20.87",
    y: "18.45",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "22.27",
    y: "18.45",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "17.38",
    y: "19.15",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "18.78",
    y: "19.15",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "20.17",
    y: "19.15",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "21.57",
    y: "19.15",
    width: "0.7",
    height: "0.7",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.51,15.18a.5.5,0,0,1,.5-.5h8.66a12,12,0,1,0-9.16,9ZM6.77,13.59a.5.5,0,1,1,0-1H12L17.4,6.76a.5.5,0,0,1,.74.68l-5.5,6a.5.5,0,0,1-.37.16Z",
    fill: "#024b6a"
  }));
};

exports["default"] = _default;